<template>
  <div class="d-flex">
    <v-autocomplete
        :menu-props="{ bottom: true, offsetY: true }"
        class="rounded-lg"
        :items="items"
        v-model="item"
        :label="label"
        item-text="name"
        item-value="value"
        :disabled="disabled"
        :multiple="multiple"
        :placeholder="placeholder"
        :return-object="false"
    ></v-autocomplete>
    <v-btn icon v-if="addNew" @click="$router.push({name: 'Category'})" class="mt-2 mr-2">
      <v-icon color="success">
        fa-plus
      </v-icon>
    </v-btn>
    <v-dialog
        v-model="addNewDialog"
        class="justify-center rounded-lg"
        persistent
        @click:outside="closeAddNewDialog"
        width="800"
    >
      <v-card class="rounded-lg pa-2">
        <v-card-title class="primary--text text-h5">
          ثبت دسته بندی جدید
        </v-card-title>
        <v-card-text>
          <v-row>
            <category-form></category-form>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="error"
              text
              @click="closeAddNewDialog"
          >
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import Brand from "@/views/product/brand/Brand";
import CategoryForm from "@/views/product/category/Category";
export default {
  name: 'CategorySelect',
  components: {CategoryForm, Brand},
  props: {
    value: {},
    addNew: {
      default: false
    },
    label: {
      default: null
    },
    placeholder: {
      default: null
    },
    disabled: {
      default: false
    },
    multiple: {
      default: false
    }
  },
  data() {
    return {
      addNewDialog: false,
      items: [],
      item: null
    };
  },
  computed: {},
  created() {
    this.getItems();
  },
  mounted() {
    this.setItem();
  },
  methods: {
    closeAddNewDialog () {
      this.addNewDialog = false
      this.getItems()
    },
    getItems() {
      this.request({
        url: this.endpoint(`product/category`),
        method: "get",
        success: data => {
          this.items = []
          for (let category of data) {
            this.items.push({
              'name': category.name,
              'value': category.id,
            })
          }
        }
      })
    },

    setItem() {
      if (this.value != this.item) this.item = this.value;
    }
  },
  watch: {
    value() {
      this.setItem();
    },
    item() {
      this.$emit("input", this.item);
    }
  }
};
</script>


<style lang="scss" scoped></style>